import { Box, Stack, Typography } from "@mui/material"
import { FC } from "react"
import { SstLockerThing } from "src/features/partners/sstThingsSlice"

interface SstLockerDisplayProps {
  locker: SstLockerThing
}

export const SstLockerDisplay: FC<SstLockerDisplayProps> = ({ locker }) => {
  return (
    <Box
      sx={{
        p: 2,
        border: "1px solid #ccc",
        borderRadius: "4px",
        // backgroundColor: "#f9f9f9",
      }}
    >
      <Stack direction="column" spacing={1}>
        <Typography variant="body1" fontWeight="bold">
          {`${locker.client_name}`}
        </Typography>
        <Typography variant="caption">{`📍 ${locker.address_1} ${locker.address_2} ${locker.city} ${locker.province} ${locker.country}`}</Typography>
        <Stack
          direction="row"
          spacing={1}
          divider={<Typography variant="caption">|</Typography>}
        >
          <Typography variant="caption">{`ID: ${locker._id}`}</Typography>

          <Typography variant="caption">{`Pin: ${locker.pin_number}`}</Typography>
          <Typography variant="caption">{`${locker.doors?.length || locker.nbDoors || 0} doors`}</Typography>

          <Typography variant="caption">{`Grid: ${
            locker.locker_grid || locker.hasLockerGrid ? "Yes" : "No"
          }`}</Typography>

          <Typography variant="caption">{`Payment: ${
            locker.payment ? "Yes" : "No"
          }`}</Typography>
        </Stack>
      </Stack>
    </Box>
  )
}
